import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React, { useMemo, useState } from 'react';
import { usePopper } from 'react-popper';
import Arrow from 'components/Arrow';
import useMergedRefs from 'hooks/useMergedRefs';
import { matchWidth, maxSize, applyMaxHeight } from './modifiers';
function usePopover(_ref) {
  var ref = _ref.ref,
    referenceRef = _ref.referenceRef,
    _ref$matchReferenceWi = _ref.matchReferenceWidth,
    matchReferenceWidth = _ref$matchReferenceWi === void 0 ? false : _ref$matchReferenceWi,
    _ref$positionFixed = _ref.positionFixed,
    positionFixed = _ref$positionFixed === void 0 ? true : _ref$positionFixed,
    _ref$adaptivePosition = _ref.adaptivePositioning,
    adaptivePositioning = _ref$adaptivePosition === void 0 ? false : _ref$adaptivePosition,
    _ref$arrowSize = _ref.arrowSize,
    arrowSize = _ref$arrowSize === void 0 ? 12 : _ref$arrowSize,
    _ref$distance = _ref.distance,
    distance = _ref$distance === void 0 ? 0 : _ref$distance,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 0 : _ref$offset,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    referenceElement = _useState2[0],
    setReferenceElement = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    popperElement = _useState4[0],
    setPopperElement = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    arrowElement = _useState6[0],
    setArrowElement = _useState6[1];
  var autoDistance = Number(arrowSize) / 2 + Number(distance);
  var modifiers = useMemo(function () {
    var allModifiers = [{
      name: 'arrow',
      options: {
        element: arrowElement
      }
    }, {
      name: 'offset',
      options: {
        offset: [offset, autoDistance]
      }
    }, {
      name: 'computeStyles',
      options: {
        gpuAcceleration: false,
        adaptive: adaptivePositioning
      }
    }, matchReferenceWidth ? matchWidth : null, maxSize, applyMaxHeight].filter(Boolean);

    // We're casting to the correct type to avoid the error "Type 'null' is not assignable to type 'Partial<Modifier<string, object>>'"
    // caused by matchReferenceWidth ? matchWidth : null, and modifiers not recognising that the nullish values are being filtered out
    return allModifiers;
  }, [autoDistance, offset, arrowElement, adaptivePositioning, matchReferenceWidth]);
  var _usePopper = usePopper(referenceElement, popperElement, {
      strategy: positionFixed ? 'fixed' : 'absolute',
      placement: placement,
      modifiers: modifiers
    }),
    styles = _usePopper.styles,
    state = _usePopper.state,
    attributes = _usePopper.attributes,
    update = _usePopper.update,
    forceUpdate = _usePopper.forceUpdate;
  var arrow = arrowSize > 0 && /*#__PURE__*/React.createElement(Arrow, {
    ref: setArrowElement,
    size: arrowSize,
    placement: state === null || state === void 0 ? void 0 : state.placement,
    style: styles.arrow
  });
  var setRef = useMergedRefs([setPopperElement, ref]);
  var setReferenceRef = useMergedRefs([setReferenceElement, referenceRef]);
  return {
    setRef: setRef,
    setReferenceRef: setReferenceRef,
    props: _objectSpread({
      style: styles.popper
    }, attributes.popper),
    arrow: arrow,
    update: update,
    forceUpdate: forceUpdate
  };
}
export default usePopover;